import { useEffect, useRef, useState } from "react";
import { FormControl, Helper, Input, InputDDI, InputDDIWrapper, InputWrapper, Label2 } from "./Style";
import { defaultTypes } from "./StyleType";
import { ReactComponent as IconInfo } from "../../../assets/icons/info.svg";
import { ReactComponent as IconError } from "../../../assets/icons/erro.svg";
import { telefoneMaskValue } from '../../../helpers/Masks/TelefoneMask';
import { DDIMaskValue } from '../../../helpers/Masks/DDIMask';
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import { celularMaskValue } from "../../../helpers/Masks/CelularMask";

interface TmpInputPhoneCustomProps {
    id: string;
    label: string;
    name: string;
    type: "mobile" | "phone";
    placeholder: string;
    placeholderDDI: string;
    value: string;
    helperIcon?: "info" | "error";
    helperText?: string;
    error?: boolean;
    disabled?: boolean;
    mandatory?: boolean;
    ref?: any;
    onChange: (e: any) => void;
    onBlur?: (e: any) => void;
}




export default function TmpInputPhoneCustom(props: TmpInputPhoneCustomProps) {

    const [_keyboardFocus, setKeyboardFocus] = useState(false);
    const [_keyboardDDIFocus, setKeyboardDDIFocus] = useState(false);
    const [_inputFocus, setInputFocus] = useState(false);
    const refInput = useRef<HTMLInputElement>(null);
    const refInputDDI = useRef<HTMLInputElement>(null);
    const labelId = `${props.id}-label`;

    
    const [_ddiValue, setDDIValue] = useState<string>("");
    const [_value, setValueTest] = useState<string>("");
    const [_firstRender, setFirstRender] = useState<boolean>(false);

    const convertToDefEventPara = (name: string, value: any) => ({
        target: {
            name, value
        }
    })

    
    useEffect(() => {
        if (!_firstRender) {
            if ((props.value === "" || props.value === undefined || props.value === null) && _ddiValue === "") {
                setDDIValue("+55");
            }
            setFirstRender(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_firstRender])

    
    useEffect(() => {

        if (props.value !== null && props.value !== undefined && props.value !== "" && _value === "" && _ddiValue === "") {

            var telefone = props.value.replace(/\D/g, '').substring(2, props.value.replace(/\D/g, '').length);
            var ddi = DDIMaskValue(props.value.replace(/\D/g, '').substring(0, 2));

            if (ddi !== undefined && (ddi.replace(/\D/g, "") === '55' || ddi === 55))  {
                if (props.type === "mobile") {
                    telefone = celularMaskValue(telefone)
                } else if (props.type === "phone") {

                    if(telefone !== undefined){

                        if (telefone.replace(/\D/g, "").length <= 10) {
                            telefone = telefoneMaskValue(telefone)
                        }else if (telefone.replace(/\D/g, "").length <= 11) {
                            telefone = celularMaskValue(telefone)
                        }

                    }
                }
            }

            setValueTest(telefone);
            setDDIValue(ddi)

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value])

    // Events
    const _handleKeyBoardEvents = (e: any) => {
        if (e.code === "Tab") {
            setKeyboardFocus(true);
            if (!_keyboardDDIFocus) {
                handleSetDDIInputFocus();
                setKeyboardDDIFocus(true)
            } else {
                handleSetInputFocus()
                setKeyboardDDIFocus(false)

            }
        } else {
            setKeyboardFocus(false);
        }
    };

    const _handleFocus = (e: any) => {
        setInputFocus(true);
    };

    const handleInputChange = (e: any) => {

        if (props.type === "mobile") {
            e.target.value = celularMaskValue(e.target.value)

            if (e.target.value.replace(/\D/g, '').length >= 12) {
                e.target.value = e.target.value.replace(/\D/g, '')
            }
        } else if (props.type === "phone") {

            if(e.target.value !== undefined){
                if (e.target.value.replace(/\D/g, "").length <= 10) {
                    e.target.value = telefoneMaskValue(e.target.value)
                }else if (e.target.value.replace(/\D/g, "").length <= 11) {
                    e.target.value = celularMaskValue(e.target.value)
                }
            }

            if (e.target.value.replace(/\D/g, '').length >= 12) {
                e.target.value = e.target.value.replace(/\D/g, '')
            }
        }

        setValueTest(e.target.value);

        //DDI + PHONE
        props.onChange(convertToDefEventPara(props.name, _ddiValue + e.target.value));
    };

    const handleInputChangeBlur = (e: any) => {
        if (props.onBlur) {

            if (props.type === "mobile") {
                e.target.value = celularMaskValue(e.target.value)

                if (e.target.value.replace(/\D/g, '').length >= 12) {
                    e.target.value = e.target.value.replace(/\D/g, '')
                }
            } else if (props.type === "phone") {

                if(e.target.value !== undefined){
                    if (e.target.value.replace(/\D/g, "").length <= 10) {
                        e.target.value = telefoneMaskValue(e.target.value)
                    }else if (e.target.value.replace(/\D/g, "").length <= 11) {
                        e.target.value = celularMaskValue(e.target.value)
                    }
                }

                if (e.target.value.replace(/\D/g, '').length >= 12) {
                    e.target.value = e.target.value.replace(/\D/g, '')
                }
            }

            setValueTest(e.target.value);

            //DDI + PHONE
            props.onBlur(convertToDefEventPara(props.name, _ddiValue + e.target.value));
        }
        setKeyboardFocus(false);
    };


    const handleInputDDIChange = (e: any) => {

        e.target.value = DDIMaskValue(e.target.value)

        setDDIValue(e.target.value);

        props.onChange(convertToDefEventPara(props.name, e.target.value + _value));

        setKeyboardDDIFocus(true)
    };

    const handleInputDDIChangeBlur = (e: any) => {
        e.target.value = DDIMaskValue(e.target.value)

        setDDIValue(e.target.value);

        props.onChange(convertToDefEventPara(props.name, e.target.value + _value));
    };

    const handleSetInputFocus = () => {
        if (refInput !== null && refInput.current !== null) {
            refInput.current.focus();
        }
    }

    const handleSetDDIInputFocus = () => {
        if (refInputDDI !== null && refInputDDI.current !== null) {
            refInputDDI.current.focus();
        }
    }

    // Passing style props to styled component
    FormControl.defaultProps = defaultTypes;
    Label2.defaultProps = defaultTypes;
    InputWrapper.defaultProps = defaultTypes;
    InputDDIWrapper.defaultProps = defaultTypes;
    Input.defaultProps = defaultTypes;
    InputDDI.defaultProps = defaultTypes;
    Helper.defaultProps = defaultTypes;

    return (
        <FormControl
            tabFocus={_keyboardFocus}
            focus={_inputFocus}
            onKeyUp={_handleKeyBoardEvents}
            error={props.error ? true : false}
            disabled={props.disabled ? true : false}>

            <div className="tabFocus">
                <Label2 htmlFor={props.id} id={labelId}>{props.label}{props.mandatory ? " *" : ""}</Label2>
                <div style={{ display: "flex" }}>
                    <InputDDIWrapper className="input-wrapper" onClick={handleSetDDIInputFocus}>
                        <InputDDI
                            ref={refInputDDI}
                            id={props.id}
                            type="text"
                            placeholder={props.placeholderDDI}
                            maxLength={4}
                            value={_ddiValue}
                            disabled={props.disabled}
                            onChange={handleInputDDIChange}
                            onBlur={handleInputDDIChangeBlur}
                            onFocus={_handleFocus}
                            aria-disabled={props.disabled}
                            aria-labelledby={labelId}
                        />
                    </InputDDIWrapper>
                    <InputWrapper className="input-wrapper" onClick={handleSetInputFocus}>
                        <Input
                            ref={refInput}
                            id={props.id}
                            type="text"
                            placeholder={props.placeholder}
                            maxLength={20}
                            value={_value}
                            disabled={props.disabled}
                            onChange={handleInputChange}
                            onBlur={handleInputChangeBlur}
                            onFocus={_handleFocus}
                            aria-disabled={props.disabled}
                            aria-labelledby={labelId}
                        />
                    </InputWrapper>
                </div>
            </div>

            <Helper disabled={props.disabled ? true : false}>
                {props.helperIcon === "error" && props.error &&
                    <span className="icon error">
                        <TmpIconCustom size="sm" icon={<IconError />} />
                    </span>
                }
                {props.helperIcon === "info" &&
                    <span className="icon">
                        <TmpIconCustom size="sm" icon={<IconInfo />} />
                    </span>
                }
                {props.helperText}

            </Helper>

        </FormControl>
    );
}

